<div
  class="go-modal"
  [ngClass]="goModalClasses()"
  (click)="backdropClick($event)"
  #goModal>
  <div
    class="go-modal__container"
    [ngClass]="{'go-modal__container--lg': modalSize === 'lg', 'go-modal__container--xl': modalSize === 'xl'}">
    <div class="go-modal__header">
      <h3 class="go-heading-3">{{ modalTitle }}</h3>
      <go-icon-button
        buttonIcon="close"
        class="go-modal__close"
        *ngIf="showCloseIcon"
        (handleClick)="closeModal()">
      </go-icon-button>
    </div>
    <div
      class="go-modal__content"
      [ngClass]="{ 'go-modal__content--no-padding': noContentPadding }">
      <ng-template go-modal-host>
      </ng-template>
    </div>
  </div>
</div>
